import { inject, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of} from 'rxjs';
import { JobDetailService } from '../../details/services/job-details.service';
import { JobDetailsResponse } from '../../details/models/details.model';
import { CircularLoaderService } from '../../../core/services/circularLoader/circular-loader.service';

@Injectable({ providedIn: 'root' })
export class DetailsResolver implements Resolve<JobDetailsResponse> {
  private jobDetailsService = inject(JobDetailService);
  private circularLoaderService = inject(CircularLoaderService)

  resolve(route: ActivatedRouteSnapshot): Observable<JobDetailsResponse> {
    this.circularLoaderService.setLoading(true)
    const id = route.paramMap.get('id')?? '';
    const ln = route.queryParamMap.get('ln') ?? '';
    if (isNaN(+id)){
      const emptyResponse: JobDetailsResponse = {
        statuscode: '300',
        message: 'Invalid job id',
        common: null,
        data: []
      };
      return of(emptyResponse)
    }
    const payload = { jobId: +id , fcatId: undefined, ln: +ln, p: undefined}
    return this.jobDetailsService.getJobDetails(payload)
  }
}
